import * as React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { applyMultiplier } from 'kilvin';
var style = function style(_ref) {
  var size = _ref.size,
    thickness = _ref.thickness,
    color = _ref.color,
    theme = _ref.theme;
  return {
    width: applyMultiplier(theme.baselineGrid)(size),
    height: applyMultiplier(theme.baselineGrid)(size),
    borderRadius: '50%',
    borderWidth: thickness,
    borderStyle: 'solid',
    borderTopColor: color,
    borderBottomColor: color,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    animationDuration: '1200ms',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationName: {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    }
  };
};
export default function Loading(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 6 : _ref2$size,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    _ref2$thickness = _ref2.thickness,
    thickness = _ref2$thickness === void 0 ? 3 : _ref2$thickness;
  var styleProps = {
    size: size,
    color: color,
    thickness: thickness
  };
  var _useFela = useFela(styleProps),
    css = _useFela.css;
  return /*#__PURE__*/React.createElement("div", {
    className: css(style)
  });
}
Loading.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number
};